import { ScriptsInterface } from '../../interfaces/scripts/scripts-interface';

export class ScriptsModel implements ScriptsInterface {
  googleMaps: { name: string; src: string } = {
    name: '',
    src: ''
  };
  googleAnalytics?: { name: string; src: string; data: { trackingId: string } };
  cookieConsent?: { name: string; src: string; data: { domainScriptId: string }; loaded?: boolean };
  metaPixel?: { name: string; src: string; data: { id: string }; loaded?: boolean };
  constructor(init?: Partial<ScriptsModel>) {
    Object.assign(this, init);
  }
}
